/*
 * Hundreds chart — 10×10 grid of day cells. Sits inside the
 * DayOfSchool card so the cells need to read on top of the cream
 * card material, not the theme bg directly.
 */

.grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-auto-rows: 1fr;
  gap: 6px;
  flex: 1;
  min-height: 0;
}

.cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--token-accent) 22%, transparent);
  background: rgba(255, 248, 232, 0.85);
  color: var(--token-text-primary);
  font-family: var(--token-font-display);
  font-weight: 700;
  font-size: clamp(16px, 1.4vw, 24px);
  cursor: pointer;
  transition:
    background var(--token-motion-control-ms) var(--token-motion-control-easing),
    border-color var(--token-motion-control-ms) var(--token-motion-control-easing),
    color var(--token-motion-control-ms) var(--token-motion-control-easing);
  padding: 0;
}

.cell:hover:not([data-marked='true']) {
  background: #fff;
  border-color: color-mix(in srgb, var(--token-accent) 55%, transparent);
}

.cell[data-marked='true'] {
  background: var(--token-accent);
  color: #fff;
  border-color: var(--token-accent);
  box-shadow: 0 2px 6px -2px rgba(190, 110, 35, 0.5);
}

.cell[data-marked='true']:hover {
  background: color-mix(in srgb, var(--token-accent) 85%, #000);
  border-color: color-mix(in srgb, var(--token-accent) 85%, #000);
}
